<template>
	<div>
		<template v-if="siteHandle == 'commercial' && properties.length">

			<tabs :heading="propertiesHeading" :class="properties.length && propertiesClosed.length ? 'header--both' : 'text-center'">

                <!--- business listings tab -->
                <tab v-if="tylerHuntington" title="Business Listings" :disabled="!listings.business.listings.length">
                    <BusinessListings
                        v-if="listings.business.listings"
                        :listings="listings.business.listings"
                        orientation="horizontal"
                        :class="{'fade' : listings.business.moreExist}"
                        view="list"
                    />

                    <div class="w-full flex flex-col justify-center items-center py-25">
                        <button v-if="listings.business.moreExist" :disabled="listings.business.loading" class="filled-button block cursor-pointer mb-60" :class="['filled-button-' + agentColor, {'opacity-50': listings.business.loading}]" @click="getBusinessListings">
                            <span class="filled-button-content filled-button--arrow">{{ listingsLinkText }}</span>
                        </button>

                        <a class="outlined-button block cursor-pointer" href="/listings?count=true&limit=500&type=residential&type=multifamily&type=land&minprice=10000&wwonly=1&sort=-listdate&sortOption=showall">
                            <span class="outlined-button--arrow outlined-button-content">View All West &amp; Woodall Listings</span>
                        </a>
                    </div>

                </tab>

				<!--- active listings tab -->
				<tab title="Active">
					<Properties
						v-if="properties"
						:listings="properties"
						orientation="horizontal"
						:class="{'fade' : morePropertiesExist}"
					/>

					<div class="w-full flex justify-center items-center py-25">
						<a class="filled-button block cursor-pointer" :class="'filled-button-' + agentColor" :href="propertiesLinkHref">
							<span class="filled-button-content">{{ propertiesLinkText }}</span>
						</a>
					</div>
				</tab>

				<!--- sold listings tab -->
				<tab title="Sold & Leased" v-if="propertiesClosed.length >= 1">
					<Properties
						:listings="propertiesClosed"
						orientation="horizontal"
						:class="{'fade' : morePropertiesClosedExist}"
						:view="view"
					/>

					<div class="w-full flex justify-center items-center py-25">
						<a class="filled-button block cursor-pointer" :class="'filled-button-' + agentColor" :href="propertiesClosedLinkHref">
							<span class="filled-button-content">{{ propertiesClosedLinkText }}</span>
						</a>
					</div>
				</tab>

			</tabs>

		</template>


		<template v-if="!loading && (listings.active.listings.length || listings.seller.listings.length || listings.buyer.listings.length)">

			<div :class="siteHandle == 'commercial' ? 'pt-100' : ''">

				<tabs @switch="selectedTitle = $event" :heading="listingsHeading" :class="listings.active.listings.length && hasSoldListings ? 'header--both' : 'text-center'">

					<!--- active listings tab -->
					<tab title="Active" :disabled="!listings.active.listings.length">
						<Listings
							v-if="listings.active.listings"
							:listings="listings.active.listings"
							orientation="horizontal"
							:class="{'fade' : listings.active.moreExist}"
							:view="view"
						/>

						<div class="w-full flex flex-col justify-center items-center py-25">
							<button v-if="listings.active.moreExist" :disabled="listings.active.loading" class="filled-button block cursor-pointer mb-60" :class="['filled-button-' + agentColor, {'opacity-50': listings.active.loading}]" @click="loadNextPage">
								<span class="filled-button-content filled-button--arrow">{{ listingsLinkText }}</span>
							</button>

                            <a class="outlined-button block cursor-pointer" href="/listings?count=true&limit=500&type=residential&type=multifamily&type=land&&minprice=10000&wwonly=1&sort=-listdate&sortOption=showall&">
								<span class="outlined-button--arrow outlined-button-content">View All West &amp; Woodall Listings</span>
							</a>
						</div>

					</tab>

					<!--- sold listings tab -->
					<tab title="Sold" :disabled="!(listings.seller.listings.length || listings.buyer.listings.length)" class="">

                        <div v-if="showSoldFilter" class="flex justify-center w-full mb-60">
                            <div class="flex items-center justify-center flex-wrap  lg:flex-no-wrap lg:justify-start w-full lg:w-auto mb-25 lg:mb-0">
                                <div class="text-xs font-secondary font-bold uppercase tracking-loose lg:mr-15 w-full lg:w-auto text-center">Filter By:</div>
                                <label for="v-select30" data-list-sort="" class="mr-15 custom-select-borderless">
                                    <div class="custom-select-wrapper">
                                        <select v-model="soldSection" class="custom-select w-full">
                                            <option value="seller" :disabled="!listings.seller.listings.length">Agent Represented Seller</option>
                                            <option value="buyer" :disabled="!listings.buyer.listings.length">Agent Represented Buyer</option>
                                        </select>
                                    </div>
                                </label>
                            </div>
                        </div>

						<Listings
							v-if="listings[tab].listings.length"
							:listings="listings[tab].listings"
							orientation="horizontal"
							:class="{'fade' : listings[tab].moreExist}"
							:view="view"
							:parentAgentId="agentMlsId"
							:agentRepresenting="soldSection"
							:showRepresentationLabel="true"
						/>

						<div class="w-full flex flex-col justify-center items-center py-25">
							<button v-if="listings[tab].moreExist" :disabled="listings[tab].loading" class="filled-button block cursor-pointer mb-60" :class="['filled-button-' + agentColor, {'opacity-50': listings[tab].loading}]" @click="loadNextPage">
								<span class="filled-button-content filled-button--arrow">{{ listingsLinkText }}</span>
							</button>

                            <a class="outlined-button block cursor-pointer" href="/listings?count=true&limit=500&type=residential&type=multifamily&type=land&&minprice=10000&wwonly=1&sort=-listdate&sortOption=showall&">
								<span class="outlined-button--arrow outlined-button-content">View All West &amp; Woodall Listings</span>
							</a>
						</div>

					</tab>

				</tabs>

			</div>

			</template>


			<template v-if="showBrokerageFallback">

				<div :class="siteHandle == 'commercial' ? 'pt-100' : ''">

					<tabs heading="West & Woodall Listings" class="text-center">

						<tab title="Active">
							<Listings
								v-if="listings.brokerage.listings"
								:listings="listings.brokerage.listings"
								orientation="horizontal"
								:class="{'fade' : listings.brokerage.moreExist}"
								:view="view"
							/>

							<div class="w-full flex flex-col justify-center items-center py-25">
								<button v-if="listings.brokerage.moreExist" :disabled="listings.brokerage.loading" class="filled-button block cursor-pointer mb-60" :class="['filled-button-' + agentColor, {'opacity-50': listings.brokerage.loading}]" @click="loadNextBrokeragePage">
									<span class="filled-button-content filled-button--arrow">{{ listingsLinkText }}</span>
								</button>

	                            <a class="outlined-button block cursor-pointer" href="/listings?count=true&limit=500&type=residential&type=multifamily&type=land&&minprice=10000&wwonly=1&sort=-listdate&sortOption=showall&">
									<span class="outlined-button--arrow outlined-button-content">View All West &amp; Woodall Listings</span>
								</a>
							</div>
						</tab>

					</tabs>

				</div>

			</template>
		</div>
	</template>

<script>
import axios from 'axios';
import algoliasearch from 'algoliasearch';

const algoliaApplicationId = process.env.ALGOLIA_APPLICATION_ID;
const algoliaSearchKey = process.env.ALGOLIA_SEARCH_APIKEY;
const client = algoliasearch(algoliaApplicationId, algoliaSearchKey);
const scoutIndexPrefix = process.env.SCOUT_INDEX_PREFIX ?? '';

// Residential agent tabs are grouped by buyer availability, not raw MLS status labels.
const ACTIVE_STATUSES = ['Active', 'ComingSoon'];
const ACTIVITY_STATUSES = ['Closed', 'Pending', 'ActiveUnderContract'];

import Listings from '../listings/listings.vue';
import BusinessListings from '../brokerageListings/brokerage.vue';
import Properties from '../properties/properties.vue';
import Tabs from '../tabs/tabs.vue';
import Tab from '../tabs/tab.vue';

// Coordinates the residential agent activity tabs and the separate commercial/brokerage sections.
export default {
	name: 'agent-listings',
	props: {
		agentName: { type: String, default: '' },
		agentId: { type: [String, Number], default: null },
		agentMlsId: { type: [String, Number], default: null },
		agentColor: { type: String, default: '' },
		siteHandle: { type: String, default: 'residential' },
	},
	data() {
		return {
            agentHasListings: null,
            listings: {
                business: {
                    loading: false,
                    listings: [],
                    moreExist: true,
                    page: 0
                },
                active: {
                    loading: false,
                    listings: [],
                    moreExist: true,
                    page: 0
                },
                seller: {
                    loading: false,
                    listings: [],
                    moreExist: true,
                    page: 0
                },
	                buyer: {
	                    loading: false,
	                    listings: [],
	                    moreExist: true,
	                    page: 0
	                },
	                brokerage: {
	                    loading: false,
	                    listings: [],
	                    moreExist: true,
	                    page: 0
	                },
	            },
			loadingListings: false,
			loadingClosedListings: false,
			listingsLinkHref: window.residentialUrl + '/listings?wwonly=1',
			listingsLinkText: 'View More',
			properties: [],
			propertiesClosed: [],
			propertyType: 'agent',
			morePropertiesExist: false,
			morePropertiesClosedExist: false,
			propertiesLinkHref: '/properties',
			propertiesClosedLinkHref: '/properties?status=closed',
			propertiesLinkText: 'See More Listings',
			propertiesClosedLinkText: 'See More Listings',
            selectedTitle: null,
            soldSection: 'seller',
			view: 'list',
		};
	},
	computed: {
        loading() {
            return this.loadingClosedListings || this.loadingListings
        },
		propertiesHeading() {
			if (this.propertyType == 'broker') return 'Pickett Sprouse Listings'
			return this.agentName + '\'s Listings'
		},
        listingsHeading() {
            if (this.tylerHuntington) return 'Tyler Huntington\'s Listings'
            if (this.selectedTitle && this.agentHasListings) {
                if (this.selectedTitle == 'Sold') {
                    return `${this.agentName}'s Recent Activity`
                } else {
                    return `${this.agentName}'s ${this.selectedTitle} Listings`
                }
            }
            return `West and Woodall Listings`
        },
        hasSoldListings() {
            return Boolean(this.listings.seller.listings.length || this.listings.buyer.listings.length)
        },
	        showSoldFilter() {
	            return Boolean(this.listings.seller.listings.length && this.listings.buyer.listings.length)
	        },
	        showBrokerageFallback() {
	            return this.siteHandle == 'residential' && !this.loading && this.agentHasListings === false && this.listings.brokerage.listings.length
	        },
		    tab() { return this.selectedTitle == 'Active' ? 'active' : this.soldSection == 'seller' ? 'seller' : 'buyer' },
        tylerHuntington() { return window.location.href.includes('tyler-huntington') },
	},
	methods: {
        loadNextPage() {

            let tab = this.tab
            let perPage = 12
            let page = this.listings[tab].page + 1
            this.listings[tab].page = page

			// Preserve separate pagination for purchasable inventory and seller/buyer sold activity.
            let urls = {
                active: this.agentListingUrl('agent', this.agentMlsId, ACTIVE_STATUSES, page, perPage),
                seller: this.agentListingUrl('agent', this.agentMlsId, ACTIVITY_STATUSES, page, perPage),
                buyer: this.agentListingUrl('salesAgent', this.agentMlsId, ACTIVITY_STATUSES, page, perPage),
            }

            this.listings[tab].loading = true
            this.getApiListings(urls[tab]).then(response => {
                if (Array.isArray(response.data) && response.data.length) {
                    let listings = response.data
                    this.listings[tab].listings = [...this.listings[tab].listings, ...listings]
                    if (this.listings[tab].listings.length >= this.getTotalCount(response)) this.listings[tab].moreExist = false
                    if (response.data.length < perPage) this.listings[tab].moreExist = false
                    if (!response.headers['link']) this.listings[tab].moreExist = false
                    this.listings[tab].loading = false
                } else {
                    this.listings[tab].moreExist = false
                    this.listings[tab].loading = false
                }
            })

        },
        getAgentResidentialListings() {

            this.loadingListings = true
            this.loadingClosedListings = true

            return Promise.all([
                this.getActiveAgentListings(),
                this.getSoldAgentListings()
            ]).then(() => {
                this.loadingListings = false
                this.loadingClosedListings = false
                this.updateAgentListingState()
            })

        },
        getActiveAgentListings() {

            let perPage = 12
            let activeUrl = this.agentListingUrl('agent', this.agentMlsId, ACTIVE_STATUSES, 0, perPage)

            return this.fetchListings(activeUrl).then(response => {
                this.listings.active.page = 0
                this.listings.active.listings = this.getResponseListings(response)
                this.listings.active.moreExist = this.responseHasMore(response, 0, perPage)
            })

        },
        getSoldAgentListings() {

            let perPage = 12
            // "Sold" is the client-facing bucket for listings that are no longer plainly purchasable.
            let sellerUrl = this.agentListingUrl('agent', this.agentMlsId, ACTIVITY_STATUSES, 0, perPage)
            let buyerUrl = this.agentListingUrl('salesAgent', this.agentMlsId, ACTIVITY_STATUSES, 0, perPage)

            return Promise.all([
                this.fetchListings(sellerUrl),
                this.fetchListings(buyerUrl)
            ]).then(([sellerResponse, buyerResponse]) => {
                this.listings.seller.listings = this.getResponseListings(sellerResponse)
                this.listings.buyer.listings = this.getResponseListings(buyerResponse)
                this.listings.seller.moreExist = this.responseHasMore(sellerResponse, 0, perPage)
                this.listings.buyer.moreExist = this.responseHasMore(buyerResponse, 0, perPage)

                if (this.listings.buyer.listings.length && !this.listings.seller.listings.length) {
                    this.soldSection = 'buyer'
                }
            })

        },
        getBusinessListings() {

            this.listings.business.loading = true

            client.initIndex(scoutIndexPrefix + 'BrokerageListings').search(
                '',
                {
                    page: this.listings.business.page,
                },
                (err, { hits, nbHits, page, nbPages } = {}) => {

                    if (err) throw err;

                    if (page + 1 == nbPages) {
                        this.listings.business.moreExist = false
                    } else {
                        this.listings.business.moreExist = true
                        this.listings.business.page ++
                    }

                    this.listings.business.listings = [...this.listings.business.listings, ...hits]
                    this.listings.business.loading = false

                }
            );

			let activityListingsUrl = this.agentListingUrl('salesAgent', this.agentMlsId, ACTIVITY_STATUSES, 0, 12)
            this.getApiListings(activityListingsUrl).then(response => {
                if (Array.isArray(response.data) || response.data.length) {
                    this.listings.buyer.listings = response.data
                    if (this.listings.buyer.listings.length && !this.listings.seller.listings.length) {
                        this.soldSection = 'buyer'
                    }
                    if (this.listings.buyer.listings.length >= response.headers['X-Total-Count']) this.listings.buyer.moreExist = false
                    if (response.data.length < 12) this.listings.buyer.moreExist = false
                } else {
                    this.listings.buyer.moreExist = false
                }
            })

        },
        agentListingUrl(field, value, statuses, page = 0, limit = 12) {
            let offset = page ? `offset=${page * limit}&` : ''
            let statusFilter = statuses.map(status => `status=${encodeURIComponent(status)}`).join('&')

            return `https://api.simplyrets.com/properties?${field}=${value}&${offset}count=true&type=residential&type=multifamily&type=land&minprice=10000&sort=-listdate&${statusFilter}&limit=${limit}`
        },
        brokerageListingUrl(statuses, page = 0, limit = 12) {
            let offset = page ? `offset=${page * limit}&` : ''
            let statusFilter = statuses.map(status => `status=${encodeURIComponent(status)}`).join('&')

            return `https://api.simplyrets.com/properties?brokers=70600&brokers=71581&${offset}count=true&type=residential&type=multifamily&type=land&minprice=10000&sort=-listdate&${statusFilter}&limit=${limit}`
        },
        getResponseListings(response) {
            return Array.isArray(response.data) ? response.data : []
        },
        getHeader(response, name) {
            return response.headers[name] || response.headers[name.toLowerCase()]
        },
        getTotalCount(response) {
            return Number(this.getHeader(response, 'X-Total-Count')) || 0
        },
        responseHasMore(response, page = 0, limit = 12) {
            let listings = this.getResponseListings(response)
            let totalCount = this.getTotalCount(response)
            let loadedCount = (page * limit) + listings.length

            if (totalCount) {
                return loadedCount < totalCount
            }

            return Boolean(this.getHeader(response, 'link')) && listings.length >= limit
        },
        updateAgentListingState() {
            let hasAgentListings = this.listings.active.listings.length || this.listings.seller.listings.length || this.listings.buyer.listings.length

            if (hasAgentListings) {
                this.agentHasListings = true
                return
            }

            this.agentHasListings = false
            if (this.siteHandle == 'residential') {
                this.getBrokerageListings()
            }
        },
		getBrokerageListings() {

            let perPage = 12
            let url = this.brokerageListingUrl(ACTIVE_STATUSES, 0, perPage)

            this.listings.brokerage.loading = true

            return this.fetchListings(url).then(response => {
                this.listings.brokerage.page = 0
                this.listings.brokerage.listings = this.getResponseListings(response)
                this.listings.brokerage.moreExist = this.responseHasMore(response, 0, perPage)
                this.listings.brokerage.loading = false
            })

        },
        loadNextBrokeragePage() {

            let perPage = 12
            let page = this.listings.brokerage.page + 1
            let url = this.brokerageListingUrl(ACTIVE_STATUSES, page, perPage)

            this.listings.brokerage.loading = true

            this.fetchListings(url).then(response => {
                if (Array.isArray(response.data) && response.data.length) {
                    this.listings.brokerage.page = page
                    this.listings.brokerage.listings = [...this.listings.brokerage.listings, ...response.data]
                    this.listings.brokerage.moreExist = this.responseHasMore(response, page, perPage)
                } else {
                    this.listings.brokerage.moreExist = false
                }

                this.listings.brokerage.loading = false
            })

        },
		getApiListings(url, type){
			return this.fetchListings(url).then(response => {
                return response
			});
		},
		fetchListings(url) {
			return axios.get(url, {
				auth: {
					username: 'dev_gkd161z1',
					password: '7331f601341j9871'
				}
			})
		},
		getProperties(id) {
			client.initIndex('listdate_desc').search(
				'',
				{
					hitsPerPage: 12,
					...id && {filters: 'brokers:' + id + ' AND status.value:active'},
					...id === undefined && {filters: 'status.value:active'},
				},
				(err, { hits, nbHits, page, nbPages } = {}) => {
					if (err) throw err;

					if (hits.length == 0 && this.propertyType == 'agent') {
						this.propertyType = 'broker'
						this.getProperties()
					}

					this.properties = hits;

					if (page + 1 == nbPages) {
						this.propertiesLinkText = 'View Pickett Sprouse Listings'
					} else {
						this.morePropertiesExist = true
					}

					if (this.propertyType == 'agent') {
						this.propertiesLinkHref = `/properties?broker=${id}`
					}
				}
			);
		},
		getPropertiesClosed(id) {
			client.initIndex('listdate_desc').search(
				'',
				{
					hitsPerPage: 12,
					...id && {filters: 'brokers:' + id + ' AND status.value:closed'},
					...id === undefined && {filters: 'status.value:closed'},
				},
				(err, { hits, nbHits, page, nbPages } = {}) => {
					if (err) throw err;

					if (hits.length == 0)
						return false;

					this.propertyType == 'agent'
					this.propertiesClosed = hits;


					if (page + 1 == nbPages) {
						//this.propertiesClosedLinkText = 'View Pickett Sprouse Listings'
					} else {
						this.morePropertiesClosedExist = true
					}

					this.propertiesClosedLinkHref = `/properties?broker=${id}&status=closed`
				}
			);
		}
	},
	created() {
		if (this.agentMlsId) {
			this.getAgentResidentialListings()
		} else if (this.siteHandle == 'residential') {
            this.agentHasListings = false
			this.getBrokerageListings()
		}
		if (this.siteHandle == 'commercial'){
			this.getProperties(this.agentId);
			this.getPropertiesClosed(this.agentId);
		}
        if (window.location.href.includes('tyler-huntington')) {
            this.getBusinessListings()
        }
	},
	components: {
		Listings,
        BusinessListings,
		Properties,
		Tabs,
		Tab
	},
};
</script>
